<template>
  <!--
  <router-link
    :to="{name: 'sequence_level', params: {sequence_id: levelId.SequenceProtoID, level_num: levelId.Number}, query: queryObject}"
  >
  -->

    <!-- TODO: del <span> element -->
    <span><slot></slot></span>
  
  <!--
  </router-link>
  -->
</template>

<script>
import { convertOptionalValueToQueryParam } from '../../util.js';

export default {
  name: 'LevelLink',

  props: {
    levelId: {
      type: Object,
      required: true,
    },

    audienceId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    queryObject() {
      return {
        audience: convertOptionalValueToQueryParam(this.audienceId),
      };
    },
  },
}
</script>
